export const inventoryPriceType = "repricing_publication";
